import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

export const Navbar = ({ onJoin }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 inset-x-0 z-50"
      data-testid="site-navbar"
    >
      <div
        className={`mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8 transition-[padding,background-color,box-shadow] duration-300 ${
          scrolled
            ? "my-2 rounded-2xl bg-white/75 backdrop-blur-xl py-3 shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-slate-100"
            : "py-5"
        }`}
        style={{ maxWidth: scrolled ? "72rem" : "80rem" }}
      >
        <Logo size="sm" />
        <div className="flex items-center gap-3">
          <span className="hidden sm:flex items-center gap-2 text-xs font-medium text-slate-500">
            <span
              className="h-2 w-2 rounded-full animate-pulse"
              style={{ backgroundColor: "var(--action-green)" }}
            />
            Launching in Bhubaneswar
          </span>
          <button
            onClick={onJoin}
            data-testid="nav-join-waitlist-button"
            className="rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-[transform,box-shadow,background-color] duration-300 hover:scale-[1.04] glow-green"
            style={{ backgroundColor: "var(--action-green)" }}
          >
            Join Waitlist
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default Navbar;
